export default __webpack_public_path__ + "static/media/logo.a997adcb.png";